module.exports = __webpack_public_path__ + "img/saddle-cloths-9.3d242fbf.svg";